export default "__VITE_ASSET__DW$cClmn__"